import { BasePermissions, IBaseSystemAreaPermissions } from '@app/core/permissions/base.permissions';
import { Injectable } from '@angular/core';
import { CurrentUserService } from '@app/core/authentication/current.user';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { HouseAndLandNationalPermission } from '@app/shared/enums/permissions/house.and.land.national.permission';

export interface IHouseAndLandNationalPermissions extends IBaseSystemAreaPermissions {
    canEdit(): boolean;
}

@Injectable()
export class HouseAndLandNationalPermissions extends BasePermissions<HouseAndLandNationalPermission> implements IHouseAndLandNationalPermissions {

    constructor(
        public readonly currentUser: CurrentUserService,
        public readonly http: HttpClient,
        public readonly router: Router) {
        super('houseandlandnational', HouseAndLandNationalPermission, currentUser, http, router);
    }

    public canView(): boolean {
        return this.permissionObject(HouseAndLandNationalPermission.CanView);
    }

    public canCreate(): boolean {
        throw new Error('Method not implemented.');
    }

    public canEdit(): boolean {
        return this.permissionObject(HouseAndLandNationalPermission.CanEdit);
    }
}
